__turbopack_context__.v({
  "nav-content-menu-arrow-link": "NavbarMenuLink-module__JYiTAq__nav-content-menu-arrow-link",
  "nav-content-menu-link": "NavbarMenuLink-module__JYiTAq__nav-content-menu-link",
});
